export interface NavItem {
  icon: string;
  label: string;
  page: string;
  route: string;
}

export interface NavGroup {
  className: string;
  title?: string;
  items: NavItem[];
}

export const navigation: NavGroup[] = [
  {
    className: 'home',
    items: [
      {
        icon: 'far fa-house',
        label: 'Home',
        page: 'home',
        route: '/trello/home',
      },
      {
        icon: 'far fa-robot',
        label: 'Ask Devin',
        page: 'card-chat',
        route: '/trello/card-chat',
      },
    ],
  },
  {
    className: 'reports',
    title: 'Reports',
    items: [
      {
        icon: 'fas fa-chart-line',
        label: 'Board Summary',
        page: 'board-summary',
        route: '/trello/reports/board-summary',
      },
      {
        icon: 'fas fa-chart-line',
        label: 'Board Summary (Data)',
        page: 'board-summary-reference',
        route: '/trello/reports/board-summary-reference',
      },
      {
        icon: 'far fa-layer-group',
        label: 'Card Details',
        page: 'card-details',
        route: '/trello/reports/card-details',
      },
      {
        icon: 'far fa-user-group',
        label: 'Member Activity',
        page: 'member-activity',
        route: '/trello/reports/member-activity',
      },
      {
        icon: 'far fa-clock',
        label: 'Time Tracking',
        page: 'time-tracking',
        route: '/trello/reports/time-tracking',
      },
    ],
  },
  {
    className: 'settings',
    title: 'Settings',
    items: [
      {
        icon: 'far fa-cog',
        label: 'Configuration',
        page: 'configuration',
        route: '/trello/configuration',
      },
    ],
  },
  {
    className: 'support',
    title: 'Support',
    items: [
      {
        icon: 'far fa-question-circle',
        label: 'Help',
        page: 'help',
        route: '/trello/help',
      },
    ],
  },
];
